module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Border Lord")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  })]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("Dear Reader,")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("Harlequin is sixty years young this year…a vibrant energetic company spinning dreams and fantasies for all those readers who love to escape for a while from the busy reality of life…. Congratulations on such a milestone!")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("As a writer for Harlequin Historical, I have always been fascinated by the emotions around love. The inspiration for "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Border Lord")])]), _vm._v(" came from the lonely face of a Scottish warrior I saw portrayed in a painting at the visitor center on Culloden Field.")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("With the lines of loss, war and battle drawn upon him I wondered about the state of his soul and about the possibility of him meeting a woman who might heal his grief and make him whole again.")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("Redemption, passion and loyalty…all the emotions that make Harlequin Historical novels such wonderful books to read.")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("On the cover of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Border Lord")])]), _vm._v(" is the popular TV personality Colin McAllister.")])])]), _c('p', {
    staticClass: "lineSpace1"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('span', [_vm._v("Sophia")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69adf48e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/borderlordthe_fm02.vue
// module id = 60
// module chunks = 0